export class MeetingInfo{
  time: any = null;
  date: any = null;
  gmt: any = null;
  weekDayTimeId: any = null;
}
